var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding-left":"20px"}},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/manage' }}},[_vm._v("网站配置")]),_c('el-breadcrumb-item',[_c('a',{attrs:{"href":"/"}},[_vm._v("文字维护")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }